module.exports = __webpack_public_path__ + "img/home.2623c842.svg";